import { Stack } from '@mui/material';
import React from 'react';

import FilterButton from '../FilterButton';
import DateSelector from './DateSelector';

export default function ContentFilters() {
  return (
    <Stack
      alignItems={'center'}
      direction="row"
      justifyContent={{
        xs: 'center',
        md: 'space-between',
      }}
    >
      <DateSelector />
      <FilterButton />
    </Stack>
  );
}
